/**
 * Стор для передачи предзаполненных данных между страницами
 *
 * Используется при копировании чужого желания — данные записываются
 * перед навигацией и считываются на целевой странице (одноразово).
 */

import { create } from 'zustand';
import type { ItemPrefillData } from '@/lib/routing/types';

interface PrefillState {
  /** Данные для предзаполнения формы */
  prefillData: ItemPrefillData | null;
  /** Записать данные перед навигацией */
  setPrefillData: (data: ItemPrefillData) => void;
  /** Считать и очистить данные (одноразовое чтение) */
  consumePrefillData: () => ItemPrefillData | null;
}

export const usePrefillStore = create<PrefillState>((set, get) => ({
  prefillData: null,
  setPrefillData: (data) => set({ prefillData: data }),
  consumePrefillData: () => {
    const data = get().prefillData;
    set({ prefillData: null });
    return data;
  },
}));
